module.exports = __webpack_public_path__ + "static/democracyworks-8c40980e0a60b7654ca0132e5a1a317e.png";